import { CheckCircleRounded } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

import { Stack } from "@/Components/v2/atoms/Stack";

interface TodoListMessageProps {
  todoItems: string[];
}

export const TodoListMessage: React.FC<TodoListMessageProps> = ({ todoItems }) => {
  return (
    <Box>
      <Stack direction="column" gap={1.5}>
        {todoItems.length > 0 && (
          <Typography variant="body1" sx={{ fontWeight: 600, fontSize: "12px" }}>
            Analyzing growth data...
          </Typography>
        )}
        {todoItems.map((item, index) => (
          <Box key={item} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {index < todoItems.length - 1 ? (
              <CheckCircleRounded sx={{ fontSize: 16, color: "success.main" }} />
            ) : (
              <CircularProgress size={16} />
            )}
            <Typography variant="body1">{item}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
